import { HTTPClient } from '../utils/request'

export default {
  update: ({ payload }) => HTTPClient.post(`/drivers/update-pis`, payload),
  audit: ({ query }) => HTTPClient.get(`/audit/pis?${query}`),
}
